import useT from "../hooks/useT"

export function useMoods() {
  const t = useT()
  return [
    { emoji: "🤣", id: "funny", displayText: t`Funny` },
    { emoji: "💪", id: "motivational", displayText: t`Motivational` },
    { emoji: "🤯", id: "mindblowing", displayText: t`Mindblowing` },
    { emoji: "💔", id: "heartbreaking", displayText: t`Heartbreaking` },
    { emoji: "🦄", id: "unique", displayText: t`Unique` },
    { emoji: "😱", id: "horrifying", displayText: t`Horrifying` },
    { emoji: "🤓", id: "smart", displayText: t`Smart` },
    { emoji: "😎", id: "cool", displayText: t`Cool` },
    { emoji: "🥰", id: "heartwarming", displayText: t`Heartwarming` },
    { emoji: "📖", id: "pageturner", displayText: t`Pageturner` },
    { emoji: "😕", id: "confusing", displayText: t`Confusing` },
    { emoji: "😴", id: "boring", displayText: t`Boring` },
  ]
}
